import { createSlice } from "@reduxjs/toolkit";
import getInvoiceByIdApi from "@custom/rtk-apis/billing/invoice/getInvoiceById";

const initialState = {
  status:"",
  result:null,
  msg:"",
  loading:false,
  error:""
};

const getInvoiceByIdSlice = createSlice({
  name: "getInvoiceByIdSlice",
  initialState,
  reducers: {
    clearGetInvoiceById: state => {
      state.status = '';
      state.result = '';
      state.msg = '';
      state.loading = false;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getInvoiceByIdApi.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getInvoiceByIdApi.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.status = payload.status;
        state.result = payload.data;
        state.msg = payload.msg;
      })
      .addCase(getInvoiceByIdApi.rejected, (state, { payload }) => {
        state.result = payload;
        state.loading = false;
      });
  },
});

export default getInvoiceByIdSlice.reducer;
export const { clearGetInvoiceById } = getInvoiceByIdSlice.actions;
